module.exports = __webpack_public_path__ + "img/logo.29b2eb3a.png";